import { useCallback } from 'react';
import { OwnerReview } from '~/contracts/vdp';
import { ResponseReview } from '~/services/vdp/contracts';
import escapeHTML from '~/utilities/escapeHTML';

const sanitizeReviews = (reviews: OwnerReview[]): OwnerReview[] =>
  reviews.map(review => ({
    ...review,
    reviewText: escapeHTML(review.reviewText),
    vehicleDescription: escapeHTML(review.vehicleDescription)
  }));

function highlightSearchTerm(reviewText: string, searchTerm: string): string {
  const searchTerms = new RegExp(
    '(' + searchTerm.replace(/\s+/g, '|') + ')',
    'gi'
  );

  return reviewText.replace(
    searchTerms,
    '<span class="text-text-inverse bg-black">$1</span>'
  );
}

const highlightSearchTerms = (
  reviews: OwnerReview[],
  searchTerm: string
): OwnerReview[] =>
  searchTerm
    ? reviews.map(review => ({
        ...review,
        reviewText: highlightSearchTerm(review.reviewText, searchTerm),
        vehicleDescription: highlightSearchTerm(
          review.vehicleDescription,
          searchTerm
        )
      }))
    : reviews;

const formatReviewDate = (date: string): string => {
  const d = new Date(date);
  const m = d.getUTCMonth() + 1;
  const y = d.getUTCFullYear();

  return m < 10 ? `0${m}/${y}` : `${m}/${y}`;
};

const mapReviewProperties = (reviews: ResponseReview[]): OwnerReview[] =>
  reviews.map(review => ({
    id: review.review_id,
    isVerified: true,
    ownerName: review.customer.name,
    ownerState: review.customer.state?.trim(),
    reviewDate: review.review_date
      ? formatReviewDate(review.review_date)
      : undefined,
    reviewRating: review.review_rating,
    reviewText: review.review_text,
    vehicleDescription: `${review.vehicle.year} ${review.vehicle.vehicle_make_model}`
  }));

export default function useGetApplyReviewsRules(searchTerm: string) {
  return useCallback(
    (reviews: ResponseReview[]) =>
      highlightSearchTerms(
        sanitizeReviews(mapReviewProperties(reviews)),
        searchTerm
      ),
    [searchTerm]
  );
}
